import store from '@/store'

export const getPurchaseOrderInfo = async id => await store.dispatch('dentalLaboratory/getPurchaseOrderInfo', id)
